import { render } from "./CreateInventoryStatusPage.vue?vue&type=template&id=196efd10"
import script from "./CreateInventoryStatusPage.vue?vue&type=script&lang=js"
export * from "./CreateInventoryStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__